import languages from './languages';
import front_end from './front_end';
import back_end from './backend';
import databases from './databases';
import { infrastructure } from './infrastructure';
import test_tools from './test_tools';

export const skills = [
  {
    title: 'Languages',
    content: languages
  },
  {
    title: 'Front End Technologies',
    content: front_end
  },
  {
    title: 'Back End Technologies',
    content: back_end
  },
  {
    title: 'Databases',
    content: databases
  },
  {
    title: 'Testing Libraries',
    content: test_tools
  },
  {
    title: 'Infrastructures',
    content: infrastructure
  }
];
